"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class TokenBucketImpl {
    constructor(semaphoreTokens) {
        this.semaphoreTokens = semaphoreTokens;
        this.tokenReleasers = [];
    }
    acquire() {
        return __awaiter(this, void 0, void 0, function* () {
            const [value, tokenReleaser] = yield this.semaphoreTokens.acquire();
            this.tokenReleasers.push(tokenReleaser);
        });
    }
    tryAcquire() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.semaphoreTokens.isLocked()) {
                return false;
            }
            yield this.acquire();
            return true;
        });
    }
    addToken() {
        const tokenReleaser = this.tokenReleasers.pop();
        tokenReleaser === null || tokenReleaser === void 0 ? void 0 : tokenReleaser();
    }
    isBucketFull() {
        return this.tokenReleasers.length === 0;
    }
}
exports.default = TokenBucketImpl;
